export const normalizeText = (text) => {
    return text
        .replace(/’/g, "'")
        .replace(/‘/g, "'")
        .replace(/“/g, '"')
        .replace(/”/g, '"')
        .replace(/«/g, '"')
        .replace(/»/g, '"')
        .replace(/\u00A0/g, ' ')
        .replace(/–|—/g, '-')
        .replace(/`/g, "'")
        .replace(/„/g, '"')
        .replace(/´/g, "'");
}

export function areTextsEqual(text1, text2) {
    return normalizeText(text1) === normalizeText(text2);
}